const state = {
  isDataReady: false,
  screen: '', // 屏幕类型（mobile, pc）
  speakerConfig: {},
  curTime: '',
  speakers: {}, // 讲师
  speakersArr: [], // 讲师
  topics: {}, // 专题
  topicsArr: [], // 专题
  training: { lectureIds: [] }, // 培训
  lectures: {}, // 议题 [包括往届推荐议题]
  currrentLecturesArr: [], // 本届议题数组
  schedules: {}, // 日程
  partners: {}, // 合作伙伴
  partnersArr: {}, // 合作伙伴
  articles: [], // 技术专栏
  tags: {}, // 标签
  tagsArr: [], // 标签
  isPastHot: 0,
  hotTopicsArr: [], // 热门专题
  guestsArr: [], // 热门讲师
  hotLecturesArr: [], // 热门议题总数据
  ads: [],
  ppt_list: '', // ppt列表
  info: {
    price: { discount: [] },
    btnApply: {},
    address: {},
    menus: [],
    contacts: [],
    scheduleDays: []
  }, // 配置信息
  config: {
    wechat_share: {}
  },
  // 通过对 urL 的解析，获取出年份或者地方
  conKeyInfo: {},
  // 网站组件引用的配置清单
  comConfig: {}
}

export default state
